import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { CountryManipulationView } from "./countryManipulation-view";

export class CountryManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت کشورها ‌';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.countries = ObservableArray.create<country>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new CountryManipulationView();
    }
    public getTypeId(): string {
        return "VM-124D63BB-7BFD-4AD7-9FC9-1D4266B14339"
    }
    public set countries(v: ObservableArray<country>) { this._countries = v; } public get countries(): ObservableArray<country> { return this._countries;} private _countries: ObservableArray<country>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCountry',{
                FilteringInformation:filteringInformation
            });
            this.countries.update(...result.Country.map(q=>{
                let r = new country(this);
                r.id = q.Id;
                r.name = q.Name;
                r.code = q.Code;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    
    async requestCountryCreation(){
        let editor = new countryEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

        async countryUpdater(country:country){
            let editor = new countryEditor(this,new UpdateServerUpdater());
            country.cloneTo(editor);
            let resultCode = await this.showPopup(editor);
            if(resultCode=='done'){
                this.loader.refresh();
            }
        }
    }

export class country extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CountryManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
    private _typedParent:CountryManipulationViewModel;

    clone(parent:CountryManipulationViewModel):country{
        let u = new country(parent);
        this.cloneTo(u);
        return u;
    }

    cloneTo(country:country){
        country.id = this.id;
        country.name = this.name;
        country.code = this.code;
    }

    async edit(){
        this._typedParent.countryUpdater(this);
    }    
}

interface IServerUpdater{
    execute(country:country):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'کشور با موفقیت ثبت شد.';
    }
    async execute(country: country): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/CreateCountry',{
            Name:country.name,
            Code:country.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'کشور با موفقیت به روز رسانی شد.';

    }
    async execute(country: country): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/UpdateCountry',{
            Id:country.id,
            Name:country.name,
            Code:country.code
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class countryEditor extends country implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:CountryManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام کشور مشخص نشده است.')
        } 
        if(stringIsNullOrEmpty(this.code)){
            result.push('کد کشور مشخص نشده است.')
        }
        return result;
    }

    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت کشور');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}

export class CountrySelectorViewModel extends SelectorBaseViewModel<countryForSelector>{
    protected async loadData(): Promise<countryForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCountry',{});
        return result.Country.map(q=>{
            let result = new countryForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

class countryForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
